// Mock data for the FAQ page.
export const faqs = [
    {
      id: 1,
      question: 'What is the DAMP program?',
      answer: 'The Department Academic Mentorship Programme (DAMP) is designed to provide students with mentorship.'
    },
    {
      id: 2,
      question: 'How can I apply for a project?',
      answer: 'Project applications are typically opened at the beginning of each semester. You can find the application portal on the "Projects" page and submit your preferences.'
    },
    {
      id: 3,
      question: 'Who is eligible for the SURP program?',
      answer: 'The Summer Undergraduate Research Program (SURP) is open to all second and third-year undergraduate students in the aerospace department with a minimum CPI of 7.5.'
    },
    {
      id: 4,
      question: 'Where can I find course reviews?',
      answer: 'You can find detailed reviews for all aerospace courses on the "Courses" page. The page includes a search function to help you find specific courses.'
    },
  ];
  